import React from 'react'
import PropTypes from 'prop-types'
import Scrollspy from 'react-scrollspy'
import Headroom from 'react-headroom'
import Scroll, { Link } from 'react-scroll'

function SpyNavigation({
  sections, actions = null, invertedColor = false, offset = 0, stickyOffset = 60,
}) {
  function scrollTo() {
    Scroll.animateScroll.scrollTo(100)
  }

  return (
    <Headroom disableInlineStyles pinStart={offset} className={stickyOffset === 100 ? 'headroom-wrapper--offer' : ''}>
      <div className={`navigation-menu--competition ${invertedColor && 'is-inverted'}`}>
        <div className="container-fixed">
          <Scrollspy
            className="nav-tabs nav-tabs--small nav-tabs--navigation-menu"
            items={sections.map(section => section.id)}
            currentClassName="is-active"
          >
            {sections.map((section) => (
              <li key={section.id}>
                <Link activeClass="is-active" to={section.title} spy smooth offset={-100} duration={500}>{section.title}</Link>
              </li>
            ))}
            {actions}
          </Scrollspy>
        </div>
      </div>
    </Headroom>
  )
}

SpyNavigation.propTypes = {
  sections: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  })).isRequired,
  actions: PropTypes.node,
  invertedColor: PropTypes.bool,
  offset: PropTypes.number,
  stickyOffset: PropTypes.number,
}

export default SpyNavigation
